export const shiftDemandFormModel = {
    formId: 'shiftDemandForm',
    formField: {
        shiftTemplateId: {
            name: 'shiftTemplateId',
            label: 'Plantilla de Turno',
            requiredErrorMsg: 'La plantilla de turno es requerida',
        },
        positionId: {
            name: 'positionId',
            label: 'Cargo',
            requiredErrorMsg: 'El cargo es requerido',
        },
        date: {
            name: 'date',
            label: 'Fecha',
            requiredErrorMsg: 'La fecha es requerida',
        },
        requiredEmployees: {
            name: 'requiredEmployees',
            label: 'Empleados Requeridos',
            requiredErrorMsg: 'La cantidad de empleados es requerida',
        }
    }
};
